module.exports = __webpack_public_path__ + "static/media/19.1fb3bc29.JPG";